<template>
  <div class="foodmanagement">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="(tabs,index) in tabsList"
        :key="index"
        :label="tabs.label"
        :name="tabs.name"
      >
        <ul class="mifan_orthogon">
          <li class="mifan_icon" v-for="(foods,index) in foodList" :key="index">
            <img src="@/assets/beadhouse/zhushi.png" alt />
            <div class="mifan_rectangle">
              <h4 class="isname">{{foods.foodName}}</h4>
              <img
                class="img_dele"
                src="@/assets/beadhouse/shanchu_icon_1.png"
                alt
                @click="handleDeleteFood(foods.id)"
              />
              <img
                class="img_change"
                src="@/assets/beadhouse/xiugai_icon_1.png"
                alt
                @click="handleEditFood(foods.foodName,foods.id)"
              />
            </div>
          </li>
          <li class="mifan_icon icon_hover">
            <img
              class="img_btn"
              src="@/assets/beadhouse/tianjia_icon.png"
              @click="handleAddFood"
            />
            <div class="mifan_rectangle_jia">
              <h4>添加菜品</h4>
            </div>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
    <!-- 修改菜的dialog -->
    <el-dialog
      :title="operation?'添加食物':'修改食物'"
      width="30%"
      :visible.sync="dialogVisibleEditFood"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form
        :model="editFood"
        label-width="100px"
        :rules="editFoodRules"
        ref="editFood"
        label-position="right"
      >
        <el-form-item style="margin-left:60px;">
          <img src="@/assets/beadhouse/zhushi.png" alt />
        </el-form-item>
        <el-form-item label="菜名:" prop="foodName">
          <el-input v-model.trim="editFood.foodName" ref="foodName" auto-complete="off" style="width:80%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleEditFood=false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormEditFood">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "FoodManagement",
  components: {},
  data() {
    return {
      foodType: 1, //食物类型
      foodId: Number, //当前食物id
      size: "medium", //按钮的尺寸
      activeName: "first",
      tabsList: [
        { label: "主食", name: "first" },
        { label: "菜品", name: "second" },
        { label: "汤类", name: "third" }
      ],
      foodList: [], //食物列表
      //修改菜的dialog
      operation: true,
      dialogVisibleEditFood: false,
      //添加菜品数据
      editFood: {
        foodName: ""
      },
      editFoodRules: {
        foodName: [
          {
            required: true,
            pattern: /[^\s]/,
            message: "不能为空",
            trigger: "blur"
          },
          { min: 1, max: 9, message: "长度在 1到 9个字符" }
        ]
      },
      editFoodLoading: false
    };
  },
  methods: {
    //tabs选项卡的点击切换
    handleClick(tab, event) {
      this.foodType = Number(tab.index) + 1;
      this.findFood();
    },

    /* 
      查询菜品 
    */
    findFood() {
      this.$postForm("omc/food/selectByType", { foodType: this.foodType }).then(
        res => {
          this.foodList = res.result;
        }
      );
    },

    /* 
      新增菜 
    */
    handleAddFood() {
      this.editFood.foodName =''
      this.dialogVisibleEditFood = true;
      this.operation = true;
      // this.$nextTick(()=>{
      //   if(this.$refs['editFood']!=undefined){
      //     this.$refs['editFood'].resetFields();
      //   }
      //   console.log(this.$refs.foodName)
      //   this.$refs.foodName.focus();
      // })
    },

    /* 
            确认添加 
     */
    submitFormEditFood() {
      this.$refs["editFood"].validate(valid => {
        //添加校验
        if (valid) {
          if (this.editFood.foodName) {
            let param = {
              foodName: this.editFood.foodName,
              foodType: this.foodType,
            };
            if( !this.operation){
              param.id =this.foodId 
            }
            this.$postJson(
              this.operation ? "omc/food/foodAdd" : "omc/food/updateById", //判断调用添加接口还是修改接口
              param
            ).then(res => {
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.dialogVisibleEditFood = false;
                this.findFood(); //重新渲染
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //关闭弹窗
    closeDialog(){
      this.editFood.foodName = ''
    },

    /* 
        删除菜
     */
    handleDeleteFood(foodId) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$postForm("omc/food/foodDelById", { id: foodId }).then(res => {
            if (res.code == 200) {
              this.findFood();
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              this.$message({
                type: "error",
                message: res.result
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    /*
        修改菜品
     */
    handleEditFood(foodName, foodId) {
      this.foodId = foodId;
      this.dialogVisibleEditFood = true;
      this.operation = false;
      this.editFood.foodName = foodName;
    }
  },
  created() {},
  mounted() {
    this.findFood();
  }
};
</script>
<style lang="scss" scoped>
.foodmanagement {
  width: 100%;
  min-height: 95%;
  background: #fefefe;
  .mifan_orthogon {
    .mifan_icon {
      width: 206px;
      height: 206px;
      margin-top: 30px;
      border: 1px #f1eff2 solid;
      float: left;
      margin: 10px 29px;
      .mifan_rectangle {
        border-top: 1px #f1eff2 solid;
        h4 {
          display: inline;
          margin-left: 12px;
          line-height: 50px;
        }
        img {
          margin: 12px 3px !important;
          float: right;
          cursor: pointer;
        }
      }
      .mifan_rectangle_jia {
        border-top: 1px #f1eff2 solid;
        h4 {
          text-align: center;
          margin: 10px 0px;
        }
      }
      img {
        margin: 25px 50px;
      }
      .img_btn {
        cursor: pointer;
      }
    }
    .icon_hover:hover {
      opacity: 0.8;
    }
  }
  li {
    list-style: none;
  }
  ul,
  li,
  h4 {
    margin: 0;
    padding: 0;
  }
}
// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: center;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
::v-deep .el-tabs__nav {
  margin-left: 40%;
}
::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
</style>
